var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hand-halloween",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"hand-halloween__inner"},[_c('svg-sprite',{attrs:{"width":"46","height":"46","icon-id":"hand-halloween","halloween":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }